import React from 'react';
import footerContent from '../data/footerData';

const Footer = () => {
  return (
    <div className="bg-white border-t">
      <footer className="mt-auto w-full max-w-[85rem] py-10 px-4 sm:px-6 lg:px-8 mx-auto">
        <div className="text-center">
          <img
            className="h-20 w-auto mx-auto"
            src="/Logo.png"
            alt="Logo"
          />
          <div className="mt-5">
            <p className="text-gray-500 font-body">{footerContent.copyright}</p>
          </div>

          <div className="mt-2 space-x-4 text-sm">
            {footerContent.links.map((link, index) => (
              <React.Fragment key={link.label}>
                {index > 0 && <span className="text-gray-500">|</span>}
                <a
                  href={link.href}
                  className="text-gray-500 hover:text-gray-700 transition-colors font-body"
                >
                  {link.label}
                </a>
              </React.Fragment>
            ))}
          </div>
        </div>

      </footer>
    </div>
  );
};

export default Footer;
